import phoneNumbers from '../../csv/phone-numbers.csv?raw'

function getPhoneNumber(deviceId: string | null) {
  if (!deviceId) return null

  const lines = phoneNumbers.trim().split('\n')
  for (let i = 1; i < lines.length; i++) {
    const [identifier, rawNumber] = lines[i].trim().split(',')
    if (identifier === deviceId) {
      return `+${rawNumber}`
    }
  }
  return null
}

export const usePhoneNumber = (deviceId: string | null) => {
  return { phoneNumber: getPhoneNumber(deviceId) }
}
